import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
} from 'react';
import { listenForCalendarOAuthResult } from '../helpers/embedMessaging';
import { persistEmbedMode } from '../helpers/embedMode';
import useEmbedMode from '../hooks/useEmbedMode';

interface EmbedContextValue {
  isEmbed: boolean;
}

const EmbedContext = createContext<EmbedContextValue>({ isEmbed: false });

export const useEmbedContext = (): EmbedContextValue => {
  return useContext(EmbedContext);
};

interface EmbedProviderProps {
  children: ReactNode;
}

const EmbedProvider: React.FC<EmbedProviderProps> = ({ children }) => {
  const isEmbed = useEmbedMode();

  useEffect(() => {
    persistEmbedMode();
  }, [isEmbed]);

  useEffect(() => {
    if (!isEmbed) {
      return;
    }

    return listenForCalendarOAuthResult(success => {
      if (success) {
        window.location.reload();
      }
    });
  }, [isEmbed]);

  const value = useMemo(() => ({ isEmbed }), [isEmbed]);

  return (
    <EmbedContext.Provider value={value}>{children}</EmbedContext.Provider>
  );
};

export default EmbedProvider;
